<template>
    <div v-if="type && type !== 'select'" class="primary-variant" :class="type">
        <template v-if="type === 'colors'">
            <template v-for="variant in filteredVariants" :key="variant.id">
                <template v-for="option in variant.options" :key="option.id">
                    <span class="color-dot rounded-circle d-inline-block"
                          :style="{backgroundColor: option.product_parameter_value.parameters_values.show_as || 'white'}"></span>
                </template>
            </template>
        </template>
        <template v-if="type === 'buttons'">
            <div class="d-flex flex-wrap ga-2 justify-center">
                <template v-for="variant in filteredVariants" :key="variant.id">
                    <v-chip
                        v-for="option in variant.options" :key="option.id"
                        :text="option.product_parameter_value.parameters_values.show_as || option.product_parameter_value.parameters_values.name"
                        rounded="lg"
                        density="compact"
                    ></v-chip>
                </template>
            </div>
        </template>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    variants: Array,
});
const primary = props.variants[0]?.primary_parameter_id;
const filteredVariants = computed(() => {
    return props.variants.map((item) => {
        return {
            id: item.id,
            options: item.options.filter((option) => {
                return option.id_parameters === primary;
            }),
        };
    });
});
const type = computed(() => filteredVariants.value[0]?.options[0].parameter.show_as);
</script>

<style scoped lang="scss">
.color-dot {
    width: 1.2em;
    height: 1.2em;
    border: 1px solid black;
    margin: .4em 0 0 .4em;
}

.primary-variant {
    &.colors {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: -.4em 0 0 -.4em;
    }

    &.buttons {
        opacity: 1;
        transform: none;
    }
}
</style>
